import { createStore, combineReducers, applyMiddleware } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { thunk } from 'redux-thunk'; // ✅ Fix here

import authReducer from './reducers/authReducer';
import codeReducer from './reducers/codeReducer';
import athleteReducer from './reducers/athleteReducer';
import businessReducer from './reducers/businessReducer';
import userReducer from './reducers/userReducer';
import internReducer from './reducers/internReducer';
import entitlementReducer from './reducers/entitlementReducer';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth'],
};

const appReducer = combineReducers({
  auth: authReducer,
  codes: codeReducer,
  athlete: athleteReducer,
  business: businessReducer,
  user: userReducer,
  intern: internReducer,
  entitlement: entitlementReducer,
});

// Log out starts every per-user slice over: the JWT (so persist:root no
// longer holds it), the athlete doc, entitlement, business and intern data.
// Only the shared code lists survive, so the next person to sign in on this
// tab never sees or saves the previous account's data.
export const rootReducer = (state, action) =>
  appReducer(action.type === 'USER_LOGOUT' ? { codes: state?.codes } : state, action);

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = createStore(persistedReducer, applyMiddleware(thunk));
const persistor = persistStore(store);

export { store, persistor };
